/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Suggest_Artifact_ChangesInputs */



/**
* | output |
* | --- |
* | "Editing document" |
*
* @param {Chat_Tool_Suggest_Artifact_ChangesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_suggest_artifact_changes = /** @type {((inputs?: Chat_Tool_Suggest_Artifact_ChangesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Suggest_Artifact_ChangesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeite Dokument")
	return /** @type {LocalizedString} */ ("Editing document")
});